module.exports = __webpack_public_path__ + "media/images/flags/dz-945a413c6ba8e484b7b1545494376723.svg";